class Temps {
    constructor(
        public id_aula: number,
        public id_usuario: number,
        public tiempo_usuario: string,
        public relacion_tiempo: string,
    ) {}
}

export const DefaultTemps: Temps = {
    id_aula: 0,
    tiempo_usuario: "",
    id_usuario: 0,
    relacion_tiempo: "",
};

export default Temps;
